import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isDesktopApp =
  typeof window !== "undefined" &&
  // Tauri globals
  (window.__TAURI__ ||
    window.__TAURI_IPC__ ||
    window.__TAURI_METADATA__ ||
    // Protocol-based detection (Tauri prod uses app://)
    (typeof window.location !== "undefined" &&
      (window.location.protocol === "app:" ||
        (window.location.origin &&
          window.location.origin.startsWith("app://")))) ||
    // UA fallback
    (typeof navigator !== "undefined" &&
      navigator.userAgent &&
      navigator.userAgent.includes("Tauri")));

if (isDesktopApp && typeof document !== "undefined") {
  document.body.classList.add("tauri-desktop");
}

root.render(
  <>
    {isDesktopApp ? (
      <div className="tauri-titlebar">
        <div className="controls">
          <div className="btn btn-close"></div>
          <div className="btn btn-min"></div>
          <div className="btn btn-max"></div>
        </div>
      </div>
    ) : null}
    <App />
  </>
);
